module.exports = "/static/assets/bf1ea1e2b4e425b9004a56839435efac.png";